export default __webpack_public_path__ + "static/media/mike_rogers.33b4ad6c.png";